import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { getApiUrl } from '../utils/config';

const SettingsContext = createContext();

export const useSettings = () => useContext(SettingsContext);

export const SettingsProvider = ({ children }) => {
    const [settings, setSettings] = useState({
        hotelName: 'HotelDelish',
        homeTitle: 'HotelDelish 🍽️',
        homeSubtitle: 'Delicious meals, order online. Experience the finest dining at your table.',
        logoUrl: '',
        restaurantStatus: 'open'
    });

    const API = getApiUrl();
    const location = useLocation();

    // Parse the hotel slug from location pathname
    const match = location.pathname.match(/^\/hotel\/([^/]+)/);
    const currentSlug = match ? match[1] : null;

    const fetchSettings = async () => {
        try {
            const res = await axios.get(`${API}/api/settings`);
            if (res.data && Object.keys(res.data).length > 0) {
                setSettings(prev => ({ ...prev, ...res.data }));
            }
        } catch (err) {
            console.error('Failed to fetch settings:', err);
        }
    };

    useEffect(() => {
        fetchSettings();

        // Listen for updates from Admin component
        const handleSettingsUpdate = () => {
            fetchSettings();
        };

        window.addEventListener('settingsUpdated', handleSettingsUpdate);
        window.addEventListener('restaurantStatusUpdated', handleSettingsUpdate);

        return () => {
            window.removeEventListener('settingsUpdated', handleSettingsUpdate);
            window.removeEventListener('restaurantStatusUpdated', handleSettingsUpdate);
        };
    }, [currentSlug]);

    useEffect(() => {
        if (settings.hotelName) {
            document.title = `${settings.hotelName} 🍽️ - Order Food Online`;
        }
    }, [settings.hotelName]);

    return (
        <SettingsContext.Provider value={settings}>
            {children}
        </SettingsContext.Provider>
    );
};
